import EmployeeApi from 'services/api/EmployeeApi';
/* Service class used to perform api calls for retrieving employees/tax pros */
class EmployeeService {
    constructor() {
        this.api = EmployeeApi.create();
    }

    async searchEmployees(searchString, onlyMyOffices, impersonateUser) {
        let response = await this.api.searchEmployees(searchString, onlyMyOffices, impersonateUser);

        if (response && response.status === 200) {
            return response.data
        }
    }
}

const employeeService = new EmployeeService();
export default employeeService;